import {use} from 'react';

import {AccountingCalculationCacheContext} from './AccountingCalculationCacheContext';

export function useAccountingCalculationCache() {
  const context = use(AccountingCalculationCacheContext);

  if (!context) {
    const error = new Error(
      'useAccountingCalculationCache must be used within an AccountingCalculationCacheProvider'
    );
    error.name = 'ContextError';
    Error.captureStackTrace?.(error, use);
    throw error;
  }

  return context;
}
